export default __webpack_public_path__ + "static/media/default-avatar.1afcf9be.svg";